





















































































































import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';

import { InsuredsPolicyInformation } from '@/common/ClaimsForm';

@Component({
	name: 'SectionsToComplete',
})
export default class SectionsToComplete extends Vue {
	@State('fields', { namespace: 'ClaimsForm' })
	private fields: InsuredsPolicyInformation;

	private findEmptyFields(values) {
		return values.filter(v => v === '').length;
	}

	private findFilledFields(values) {
		return values.filter(v => v !== '').length;
	}

	private getTotalFields(values) {
		const countKeys = obj => {
			if (typeof obj !== 'object' || obj === null) {
				return 0;
			}
			const keys = Object.keys(obj);
			let sum = keys.length;
			keys.forEach(key => (sum += countKeys(obj[key])));
			return sum;
		};

		return countKeys(values);
	}

	private getTotalFilledFields(values) {
		const countKeys = obj => {
			if (typeof obj !== 'object' || obj === null) {
				return 0;
			}
			const keys = Object.keys(obj);
			let sum = keys.filter(k => {
				return typeof obj[k] !== 'object' && obj[k] !== '';
			}).length;
			keys.forEach(key => {
				return (sum += countKeys(obj[key]));
			});
			return sum;
		};

		return countKeys(values);
	}

	private calcualatePercentage(values) {
		try {
			return (this.getTotalFilledFields(values) / this.getTotalFields(values)) * 100;
		} catch (e) {
			// console.log('error', e);
		}
	}
}
